import { render, staticRenderFns } from "./SendMessageButton.vue?vue&type=template&id=090be2b2&scoped=true&"
import script from "./SendMessageButton.vue?vue&type=script&lang=js&"
export * from "./SendMessageButton.vue?vue&type=script&lang=js&"
import style0 from "./SendMessageButton.vue?vue&type=style&index=0&id=090be2b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090be2b2",
  null
  
)

/* custom blocks */
import block0 from "./SendMessageButton.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports